<template>
  <div>
    <div class="form-check form-check-inline hide-result-form" ref="form-check-show-average">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-show-average"
          v-model="slideActive.scale.showAverage"
          @change="$emit('updateSettingSlide', 15)"
        />
        <label
          class="custom-control-label"
          for="check-show-average"
        >{{ $i18nPresenter.t('Show the average line for all statements') }}</label>
      </div>
    </div>

    <div class="form-check form-check-inline hide-result-form" ref="form-check-must-rate">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-must-rate"
          v-model="slideActive.scale.mustRate"
          @change="$emit('updateSettingSlide', 16)"
        />
        <label class="custom-control-label" for="check-must-rate">{{ $i18nPresenter.t('Must rate all statements') }}</label>
        <span class="pl-1 pr-3 title-table-presentation-tooltip">
          <b-button
            v-tooltip="$i18nPresenter.t('Uncheck to allow participants to skip statement(s)')"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },
}
</script>

<style lang="scss" scoped>
.form-check-inline {
  @media (max-width: 320px) {
    &.hide-result-form {
      margin-right: 0;
    }
  }
}
</style>
